import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/social/instagram.svg")